import { render, staticRenderFns } from "./ScoreBoard.vue?vue&type=template&id=4d8de5e9&lang=pug&"
import script from "./ScoreBoard.vue?vue&type=script&lang=ts&"
export * from "./ScoreBoard.vue?vue&type=script&lang=ts&"
import style0 from "./ScoreBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports